import { render, staticRenderFns } from "./ApprovalStatusIcon.vue?vue&type=template&id=4582fd5e"
import script from "./ApprovalStatusIcon.vue?vue&type=script&lang=js"
export * from "./ApprovalStatusIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Dev\\WorldManager\\src\\WorldManager.Web\\client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4582fd5e')) {
      api.createRecord('4582fd5e', component.options)
    } else {
      api.reload('4582fd5e', component.options)
    }
    module.hot.accept("./ApprovalStatusIcon.vue?vue&type=template&id=4582fd5e", function () {
      api.rerender('4582fd5e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ApprovalStatusIcon.vue"
export default component.exports